import React, { Fragment } from 'react';
import {
    dateFilterInput,
    dateFilterClear,
    handleDateFilterSubmit,
} from '../../redux/actions/returns/return.actions';
import { connect } from 'react-redux';

function LogsDateFilter({
    returns: { date_from },
    dateFilterInput,
    dateFilterClear,
    handleDateFilterSubmit,
    filterBy,
    pageOrigin,
    movementFilter,
}) {
    return (
        <Fragment>
            <form
                onSubmit={(e) =>
                    handleDateFilterSubmit(
                        e,
                        filterBy,
                        pageOrigin,
                        movementFilter
                    )
                }
            >
                <section className="row mt-1 f-regular">
                    <div className="col-sm-12 col-md-4">
                        <div className="form-group row no-gutters">
                            <label className="col-4 text-center">
                                Date: <span className="text-danger">*</span>
                            </label>
                            <div className="col-8">
                                <input
                                    type="date"
                                    name="date_from"
                                    value={date_from}
                                    onChange={dateFilterInput}
                                    className="form-control"
                                    required
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12 col-md-4">
                        <div className="btn-group" role="group">
                            <button className="btn btn-primary">Filter</button>
                            <a
                                onClick={() =>
                                    dateFilterClear(filterBy, pageOrigin)
                                }
                                className="btn btn-danger text-white"
                            >
                                <i className="ft ft-spinner"></i> Clear
                            </a>
                        </div>
                    </div>
                </section>
            </form>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({
    returns: state.returns,
});

export default connect(mapStateToProps, {
    dateFilterInput,
    dateFilterClear,
    handleDateFilterSubmit,
})(LogsDateFilter);
